export default __webpack_public_path__ + "static/media/gsda_logo.d19b76f4.jpg";